export function ImmerseBg(){
    return(
        <div className="background-img">
        <img src="https://assets.website-files.com/62b46e994f1dca9e9be49474/62b46e994f1dca5b10e4951c_Chat%20Background.jpg"
            alt="#" />
    </div>
    )
}